import { useHits, UseHitsProps } from 'react-instantsearch';

export const HitsVirtual = (props: UseHitsProps) => {
  useHits(props);
  return null;
};
